export const DRUG_LOOKUP_ASSOCIATION = {
  EXISTING_PRODUCT: 'EXISTING_PRODUCT',
  NEW_PRODUCT: 'NEW_PRODUCT',
} as const;

export type DrugLookupAssociationType = typeof DRUG_LOOKUP_ASSOCIATION[keyof typeof DRUG_LOOKUP_ASSOCIATION];
